export default __webpack_public_path__ + "ace19060867a0563744e15b33fa076c2.png";